import { call, put } from 'redux-saga/effects';
import * as action from '../actions/qr';
import { post } from '../../utils/api';
import { modalDeletingPieceClose } from '../actions/modal';

export function* qrData({ payload }) {
  try {
    const response = yield call(post,
      '/grid/searchqrcode/',
      {
        barcode: payload.barcodes,
        plantId: payload.plantId
      });
    yield put(action.qrDataSuccess(response));
  } catch (error) {
    yield put(action.qrDataFail(error.response.data));
  }
}

export function* qrListData({ payload }) {
  try {
    const response = yield call(post,
      '/grid/searchqrcodedata/',
      {
        plantId: payload.plantId,
        filter: payload.filter,
        dateFrom: payload.dateFrom,
        dateTo: payload.dateTo,
        actual: payload.actual
      });
    yield put(
      action.qrDataListSuccess(
        response && response.length
          ? response
            .map((item) => ({
              ...item,
              commonNumber: `${(item.heatId === null)
                ? ''
                : item.heatId}-${item.cgId}-${item.actualPieceId}`,
              sizes: `${item.thick}x${item.width}`,
              commonNumberMKM: `${item.qcId}/${item.cgId}/${item.actualPieceId}`,
              endCustomerName: `${(item.endCustomerName === null)
                ? item.customerName
                : item.endCustomerName}`,
              stornoFlag: item.stornoFlag === 'Y',
              onHoldFlag: item.onHoldFlag === 'Y',
              hasShippingPlan: item.hasShippingPlan === 'Y'
            }))
          : response
      )
    );
  } catch (error) {
    yield put(action.qrDataListFail(error.response.data));
  }
}

export function* qrDeletePiece({ payload }) {
  try {
    const response = yield call(post,
      '/grid/searchqrcodecancelscan/',
      {
        items: payload.items,
        plantId: payload.plantId
      });
    yield put(action.deletingPieceSuccess(response));
    yield put(action.qrDataList({ plantId: payload.plantId }));
    yield put(modalDeletingPieceClose());
  } catch (error) {
    yield put(action.deletingPieceFail(error.response.data));
  }
}
